// @store/Finance/BankSettlement/BankSettlementSlice.ts

import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { BankSettlementModel } from './BankSettlementModels';

export const addBankSettlement = createAsyncThunk(
  'BankSettlement/addBankSettlement',
  async (item: BankSettlementModel, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('CashManagment/AddBankSettlement', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const updateBankSettlement = createAsyncThunk(
  'BankSettlement/updateBankSettlement',
  async (item: BankSettlementModel, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('CashManagment/UpdateBankSettlement', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const deleteBankSettlement = createAsyncThunk(
  'BankSettlement/deleteBankSettlement',
  async (id: string, { rejectWithValue }) => {
    try {
      // ✅ الأكثر شيوعاً: POST body { id }
      const { data } = await ntxAPI.post('CashManagment/DeleteBankSettlement', { id });
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

export const getBankSettlementById = createAsyncThunk(
  'BankSettlement/getBankSettlementById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`CashManagment/GetBankSettlementById?Id=${id}`);
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);

const initialState: {
  BankSettlementById: BankSettlementModel;
  loading: boolean;
  error: any | null;
} = {
  BankSettlementById: {} as BankSettlementModel,
  loading: false,
  error: null
};

const BankSettlementSlice = createSlice({
  name: 'BankSettlement',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      // Get By Id
      .addCase(getBankSettlementById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBankSettlementById.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        // أحياناً الـ API يرجع {succeeded, data} وأحياناً يرجع DTO مباشرة
        state.BankSettlementById = action.payload?.data ?? action.payload;
      })
      .addCase(getBankSettlementById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default BankSettlementSlice.reducer;